import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import "./ContactForm.css";

const ContactForm = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const { t } = useTranslation();

  const sendEmail = (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const userName = formData.get("user_name");
    const userEmail = formData.get("user_email");
    const userPhone = formData.get("user_phone");
    const message = formData.get("message");

    if (!userName || !userEmail || !userPhone || !message) {
      setStatusMessage(t("contactForm.required"));
      return;
    }

    const emailData = {
      from_name: userName,
      reply_to: userEmail,
      user_phone: userPhone,
      message: message,
      to_name: "Harut",
    };

    emailjs
      .send(
        "service_wszckve",
        "template_75wpo3x",
        emailData,
        "PQwZpkukfTfGWmWEP",
      )
      .then((result) => {
        console.log(result.text);
        setStatusMessage(t("contactForm.success"));
        form.current.reset();
      })
      .catch((error) => {
        console.log(error.text);
        setStatusMessage(t("contactForm.error"));
      });
  };

  return (
    <div className="StyledContactForm">
      <div className="contacttext">
        <h2>
          {t("contactForm.title1")} <span>{t("contactForm.title2")}</span>
        </h2>
        <p>{t("contactForm.description")}</p>
      </div>

      <form ref={form} onSubmit={sendEmail}>
        <label htmlFor="user_name">{t("contactForm.name")}</label>
        <input
          id="user_name"
          type="text"
          name="user_name"
          placeholder={t("contactForm.name")}
          required
        />
        <label htmlFor="user_email">{t("contactForm.email")}</label>
        <input
          id="user_email"
          type="email"
          name="user_email"
          placeholder={t("contactForm.email")}
          required
        />
        <label htmlFor="user_phone">{t("contactForm.phone")}</label>
        <input
          id="user_phone"
          type="tel"
          name="user_phone"
          placeholder={t("contactForm.phone")}
          required
        />
        <label htmlFor="message">{t("contactForm.message")}</label>
        <textarea
          id="message"
          name="message"
          placeholder={t("contactForm.message")}
          required
        />
        <button type="submit" className="btn primary">
          {t("contactForm.send")}
        </button>
      </form>

      {statusMessage && <p role="status" aria-live="polite">{statusMessage}</p>}
    </div>
  );
};

export default ContactForm;
